import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TPage } from '@/interfaces/constructor.interfaces';

import type { InstallationState } from './types';

const initialState: InstallationState = {
  page: {
    ready: false,
    visited: [],
  },
  filters: {
    ready: false,
  },
};

export const installationSlice = createSlice({
  name: 'installation',
  initialState,
  reducers: {
    setPageReady: (state, action: PayloadAction<boolean>) => {
      state.page.ready = action.payload;
    },
    setFiltersReady: (state, action: PayloadAction<boolean>) => {
      state.filters.ready = action.payload;
    },
    setPage: (state, action: PayloadAction<TPage | undefined>) => {
      state.page.current = action.payload;
    },
    addVisitedPage: (state, action: PayloadAction<TPage>) => {
      state.page.visited = Array.from(new Set([...state.page.visited, action.payload]));
    },
  },
});

export default installationSlice.reducer;
